import { NameResourceItem } from "../NameResourceItem";
import { createListResource } from "../../list";
import { createFullClassResource } from "../../fullResource";

export class RodzajKomponentu extends NameResourceItem {}

export const rodzajKomponentuResource = createFullClassResource(
  "plm/rodzajkomponentu/",
  RodzajKomponentu,
);
